import { withFirebase } from "../Firebase";
import "react-big-calendar/lib/css/react-big-calendar.css";
import React, { Component } from "react";

import { AuthUserContext } from "../Session";
import { Link } from "react-router-dom";

import * as ROUTES from "../../constants/routes";

import {
  Switch,
  Intent,
  ControlGroup,
  HTMLSelect,
  Button,
} from "@blueprintjs/core";
import Select from "react-select";

import { Grid, Row, Col } from "react-flexbox-grid";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import Spinner from "react-md-spinner";

import "./index.css";

// required property for react-big-calendar
const localizer = momentLocalizer(moment);


//https://github.com/instructure-react/react-select-box
class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      events: [],
      consaltation: [],
      isEvents: true,
      eventDetailId: "",
      filter: "",
      selectionList: [],
      filtersSelected: [],
    };
  }

  componentDidMount() {
    this.unsubscribe = this.props.firebase
      .calendarevents()
      .onSnapshot((snapshot) => {
        let events = [];
        this.setState({ loading: true });
        snapshot.forEach((doc) => {
          let start = doc.data().start.toDate();
          let end = doc.data().end.toDate();
          let title = doc.data().title;
          let cid = doc.id;
          let id = doc.data().eventId;
          let event_type = doc.data().event_type;
          let pn = doc.data().hasOwnProperty("program_name")
            ? doc.data().program_name
            : "N/A";
          let city = doc.data().city;

          events.push({
            cid: cid,
            title: title,
            start: start,
            end: end,
            id: id,
            event_type: event_type,
            program_name: pn,
            city: city,
          });
        });

        this.setState({
          events: events,
          loading: false,
        });
      });
  }

  componentWillMount() {
    this.unsubscribe && this.unsubscribe();
  }

  handleChangeCalendar = () => {
    /*
            change eventList
             */
  };

  styleEvent = (event, start, end, isSelected) => {
    let colors_map = {
      Training: "#baf8ff",
      Challenges: "#f7ffd6",
      "Hands-On Workshop": "#bac2ff",
      Bootcamp: "#bac2ff",
      Roadshow: "#f4d6ff",
      "Meet-Up": "#ffd6dd",
      Consultations: "#d6ffda",
      Lecture: "#bae3ff",
      Mentorship: "#fff1d6",
      Internal: "#f0d6ff",
    };
    let selected_colors_map = {
      Training: "#8cf0fc",
      Challenges: "#e9ff8f",
      "Hands-On Workshop": "#8391fc",
      Bootcamp: "#8795ff",
      Roadshow: "#dc83fc",
      "Meet-Up": "#ff6b84",
      Consultations: "#77fc84",
      Lecture: "#8bcffc",
      Mentorship: "#fcd688",
      Internal: "#c869ff",
    };

    let backgroundColor = isSelected
      ? selected_colors_map[event.event_type]
      : colors_map[event.event_type];

    let style = {
      backgroundColor: backgroundColor,
      borderRadius: "2px",
      opacity: 0.8,
      color: "black",
      border: "1px",
      display: "block",
    };
    return {
      style: style,
    };
  };

  filterEvents = (events) => {
    let filtered_events = [];
    let { filtersSelected, filter } = this.state;
    if (filter === "None" || filtersSelected.length === 0) return events;

    for (let i = 0; i < filtersSelected.length; i++) {
      filtered_events = filtered_events.concat(
        events.filter((event) => event[filter] === filtersSelected[i].value)
      );
    }

    return filtered_events;
  };

  handleFilterChange = (filter) => {
    let { events } = this.state;
    let select_options = [];
    this.setState({ filter: filter, filtersSelected: [], selectionList: [] });
    if (filter === "None") return;
    for (let i = 0; i < events.length; i++) {
      if (events[i][filter] === undefined) {
        continue;
      }

      if (select_options.indexOf(events[i][filter]) === -1) {
        select_options.push(events[i][filter]);
      }
    }

    let list = [];
    for (let i = 0; i < select_options.length; i++) {
      list.push({ label: select_options[i], value: select_options[i] });
    }

    this.setState({ selectionList: list });
  };

  render() {
    const FILTER_OPTIONS = [
      { label: "Select Filter", value: "None" },
      { label: "City", value: "city" },
      { label: "Event type", value: "event_type" },
      { label: "Program name", value: "program_name" },
    ];

    const { loading, events, selectionList, filtersSelected } = this.state;
    return (
      <div>
        <AuthUserContext.Consumer>
          {(authUser) =>
            authUser ? (
              <div>
                <Grid className=".grid-size">
                  <Row>
                    <Col xs={4}>
                      <h1 className=".margin-left"> Upcoming Events </h1>
                    </Col>
                  </Row>
                  <Row middle="xs">
                    <Col>
                      <HTMLSelect
                        options={FILTER_OPTIONS}
                        onChange={(value) =>
                          this.handleFilterChange(value.currentTarget.value)
                        }
                      />
                    </Col>
                    <Col xs={4}>
                      <Select
                        value={filtersSelected}
                        options={selectionList}
                        isMulti
                        maxMenuHeight={100}
                        onChange={(value) => {
                          if (value !== null) {
                            let filterlist = [];
                            for (let i = 0; i < value.length; i++) {
                              filterlist.push(value[i]);
                            }
                            this.setState({ filtersSelected: filterlist });
                          } else {
                            this.setState({ filtersSelected: [] });
                          }
                        }}
                      />
                    </Col>
                  </Row>
                  <Row middle="xs">
                    <Col xs={10.5}>
                      <ControlGroup vertical={true}>
                        <Switch
                          onChange={this.handleChangeCalendar}
                          labelElement="Events"
                        />
                        <Switch
                          onChange={this.handleChangeCalendar}
                          labelElement="Consultations"
                        />
                      </ControlGroup>
                    </Col>
                    <Col>
                      <Link to={ROUTES.ADDEVENT}>
                        <Button intent={Intent.PRIMARY} icon="add">
                          Add New Event
                        </Button>
                      </Link>
                    </Col>
                  </Row>
                  <Row middle="xs">
                    {loading ? (
                      <div>
                        <Spinner
                          size={100}
                          style={{ marginTop: "200px", marginLeft: "550px" }}
                          color1="#1673b5"
                        />
                      </div>
                    ) : (
                      <Col xs={12}>
                        <Calendar
                          popup={true}
                          localizer={localizer}
                          events={this.filterEvents(events)}
                          startAccessor="start"
                          endAccessor="end"
                          onSelectEvent={(event) =>  window.location.replace(`/eventdetails/${event.id}`)}
                          eventPropGetter={(event, start, end, isSelected) =>
                            this.styleEvent(event, start, end, isSelected)
                          }
                        />
                      </Col>
                    )}
                  </Row>
                </Grid>
              </div>
            ) : (
              <SignIn />
            )
          }
        </AuthUserContext.Consumer>
      </div>
    );
  }
}

const SignIn = (props) => (
  <div>
    <Grid>
      <Row>
        <h1>
          Please <Link to={ROUTES.SIGN_IN}> Sign In </Link> ! 
        </h1> 
      </Row> 
    </Grid> 
  </div>
);

export default withFirebase(HomePage);
